import {loginAxios} from '../../config/axios.config';

export const getInvoiceDetails = async (params) => {
    try {
        const { data } = await loginAxios.post(`payment/generate_invoice_details`, params, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const createNewInvoice = async (params) => {
    try {
        const { data } = await loginAxios.post(`payment/create_invoice`, params, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const updateInvoice = async (params) => {
    try {
        const { data } = await loginAxios.post(`payment/update_invoice/${params?.invoice_id}`, params?.payload, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};

export const printInvoice = async (id) => {
    try {
        const { data } = await loginAxios.get(`payment/print_invoice/${id}`, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const invoiceUpdateDetails = async ({invoice_id, FcId}) => {
    try {
        const { data } = await loginAxios.get(`payment/invoice_details/${invoice_id}?fc_id=${FcId}`, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const getinvoicePayments = async (param) => {
    try {
        const { data } = await loginAxios.get(`payment/invoice-details/${param}`, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const getDesignerMaster = async (id) => {
    try {
        const { data } = await loginAxios.get(`payment/master_fc`, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};


export const acceptTNC = async (params) => {
    try {
        const { data } = await loginAxios.put(`payment/accept_tnc`, params, {
            headers: {
                'x-auth-token': localStorage.getItem('accessToken')
            }
        });
        return data;

    } catch (error) {
        return Promise.reject(error);
    }
};